<script setup>
import { HoverCardTrigger } from 'radix-vue';

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
});
</script>

<template>
    <HoverCardTrigger v-bind="props">
        <slot />
    </HoverCardTrigger>
</template>
